export const RESTRICTED_COUNTRIES = ['RU', 'BY', 'VE', 'CU', 'IR', 'KP', 'SD', 'SY'];
